<script setup>
const props = defineProps({
  label: {
    required: true,
  },
  value: {
    required: true,
  }
})
</script>

<template>
  <div class="mx-auto text-center flex max-w-xs flex-col gap-y-4 capitalize">
    <div class="text-base leading-7 text-gray-600">{{ label }}</div>
    <div class="order-first text-3xl font-semibold tracking-tight text-gray-900 sm:text-5xl">{{ value.toLocaleString() }}</div>
  </div>
</template>

